import { FloorSectionId } from './floorLayouts';
import ShelfButton from './ShelfButton';
import { TShelves } from 'utils/types';

type SecondFloorMapProps = {
  sectionId: FloorSectionId;
  shelvesByCode: Record<string, TShelves>;
  selectedCode?: string | null;
  onSelectShelf: (code: string, shelf?: TShelves) => void;
};

const SecondFloorMap = ({
  sectionId,
  shelvesByCode,
  selectedCode,
  onSelectShelf
}: SecondFloorMapProps) => {
  const common = {
    shelvesByCode,
    selectedCode,
    onSelect: onSelectShelf
  };

  if (sectionId === '2C') {
    return (
      <div className="warehouse-floor-map warehouse-floor-2c">
        <div className="warehouse-floor-label warehouse-floor-label-red">2C</div>
        <ShelfButton code="2C13" className="warehouse-shelf-2c13" {...common} />
        <div className="warehouse-floor-2c-body">
          <div className="warehouse-floor-col">
            <div className="warehouse-shelf-pair">
              <ShelfButton code="2C6" {...common} />
              <ShelfButton code="2C5" {...common} />
            </div>
            <div className="warehouse-shelf-pair">
              <ShelfButton code="2C4" {...common} />
              <ShelfButton code="2C3" {...common} />
            </div>
            <div className="warehouse-shelf-pair">
              <ShelfButton code="2C2" {...common} />
              <ShelfButton code="2C1" {...common} />
            </div>
          </div>
          <div className="warehouse-floor-col">
            <div className="warehouse-shelf-pair">
              <ShelfButton code="2C7" {...common} />
              <ShelfButton code="2C8" {...common} />
            </div>
            <div className="warehouse-shelf-pair">
              <ShelfButton code="2C9" {...common} />
              <ShelfButton code="2C10" {...common} />
            </div>
            <div className="warehouse-shelf-pair">
              <ShelfButton code="2C11" {...common} />
              <ShelfButton code="2C12" {...common} />
            </div>
          </div>
        </div>
        <div className="warehouse-floor-hint">2B ↓</div>
      </div>
    );
  }

  if (sectionId === '2B') {
    return (
      <div className="warehouse-floor-map warehouse-floor-2b">
        <div className="warehouse-floor-label warehouse-floor-label-red">2B</div>
        <div className="warehouse-floor-2b-top">
          <div className="warehouse-wall">WALL</div>
          <ShelfButton code="2B1" className="warehouse-shelf-tall" {...common} />
          <ShelfButton code="2B2" className="warehouse-shelf-tall" {...common} />
          <ShelfButton code="2B3" className="warehouse-shelf-tall" {...common} />
          <div className="warehouse-aisle" />
          <ShelfButton code="2B4" className="warehouse-shelf-tall" {...common} />
          <ShelfButton code="2B5" className="warehouse-shelf-tall" {...common} />
          <ShelfButton code="2B6" className="warehouse-shelf-tall" {...common} />
        </div>
        <div className="warehouse-floor-2b-bottom">
          <div className="warehouse-wall">WALL</div>
          <ShelfButton code="2B8" className="warehouse-shelf-wide" {...common} />
          <div className="warehouse-wall">WALL</div>
          <div className="warehouse-floor-hint warehouse-floor-2a-marker">2A ←</div>
          <div className="warehouse-wall">WALL</div>
          <ShelfButton code="2B7" className="warehouse-shelf-wide" {...common} />
          <div className="warehouse-wall">WALL</div>
        </div>
        <div className="warehouse-floor-hint warehouse-stairs">← STAIRS</div>
      </div>
    );
  }

  return (
    <div className="warehouse-floor-map warehouse-floor-2a">
      <div className="warehouse-floor-label warehouse-floor-label-red">2A</div>
      <div className="warehouse-floor-2a-body">
        <div className="warehouse-floor-2a-left">
          <div className="warehouse-nested-shelf">
            <ShelfButton code="2A1" className="warehouse-nested-frame" {...common} />
            <div className="warehouse-nested-inner">
              <ShelfButton code="2A2" {...common} />
              <ShelfButton code="2A3" {...common} />
              <ShelfButton code="2A4" {...common} />
              <ShelfButton code="2A5" {...common} />
            </div>
          </div>
          <ShelfButton code="2A6" className="warehouse-shelf-wide" {...common} />
          <div className="warehouse-floor-hint">WINDOW</div>
        </div>
        <div className="warehouse-floor-2a-right">
          <div className="warehouse-stairs-block">
            <div className="warehouse-floor-hint">← STAIRS</div>
            <ShelfButton code="2A11" className="warehouse-shelf-wide" {...common} />
          </div>
          <ShelfButton code="2A10" className="warehouse-shelf-wide" {...common} />
          <div className="warehouse-shelf-pair warehouse-shelf-pair-row">
            <ShelfButton code="2A8" className="warehouse-shelf-tall" {...common} />
            <ShelfButton code="2A9" className="warehouse-shelf-tall" {...common} />
          </div>
          <ShelfButton code="2A7" className="warehouse-shelf-wide" {...common} />
        </div>
      </div>
    </div>
  );
};

export default SecondFloorMap;
